import { useObserver } from 'mobx-react-lite';
import React from 'react';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import CartV1 from './CartV1';
import CartV2 from './CartV2';
import { CartProps } from '../types/CartProps';

const Cart: React.FC<CartProps> = ({ className, ...props }) => {
  const version = parseInt((globalThis as any)['WITHWINE_CART_VERSION']) || 1;
  return useObserver(() => {
    return version == 2 ? (
      <CartV2 className={className} {...props}></CartV2>
    ) : (
      <CartV1 className={className} {...props}></CartV1>
    );
  });
};

/**
 * Loads the V1 version of Cart unless window.WITHWINE_CART_VERSION === 2
 */
export default Cart;
